import Vue from 'vue'
import Router from 'vue-router'

import Login from '@/views/Login'
import CreateAccount from '@/views/CreateAccount'
import ForgotPassword from '@/views/ForgotPassword'
import Dashboard from '@/views/Dashboard'
import DashboardOrders from '@/components/dashboard/DashboardOrders'
import DashboardDelivery from '@/components/dashboard/DashboardDelivery'
import DashboardIncidences from '@/components/dashboard/DashboardIncidences'
import DashboardEDF from '@/components/dashboard/DashboardEDF'
import DashboardEDD from '@/components/dashboard/DashboardEDD'
import DashboardAdmin from '@/components/dashboard/DashboardAdmin'

import store from '@/store'

const _loadComponent = (to, next) => store.state.user.data.auth ? next() : next('/')

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/create',
      name: 'CreateAccount',
      component: CreateAccount
    },
    {
      path: '/forgot',
      name: 'ForgotPassword',
      component: ForgotPassword
    },
    {
      path: '/dashboard',
      component: Dashboard,
      beforeEnter: (to, from, next) => _loadComponent(to, next),
      children: [
        {
          path: '',
          name: 'Orders',
          component: DashboardOrders
        },
        {
          path: 'completed',
          name: 'Completed',
          component: DashboardDelivery
        },
        {
          path: 'incidences',
          name: 'Incidences',
          component: DashboardIncidences
        },
        {
          path: 'edf',
          name: 'Edf',
          component: DashboardEDF
        },
        {
          path: 'edd',
          name: 'Edd',
          component: DashboardEDD
        },
        {
          path: 'admin',
          name: 'Admin',
          component: DashboardAdmin
        }
      ]
    },
    {
      path: '*',
      beforeEnter: (to, from, next) => _loadComponent(to, next)
    }
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router.js